export const aboutMe = {
	firstParagraph: `Currently I'm focused on skills as an enhanced Front End Developer, and some${' '}
									 SoftSkills that allow me to be a better Developer: Effective Communication,${' '}
									 Leadership...I've also been focusing on English, I'm taking the course at${' '}
									 Wise Up.`,
	secondParagraph: `I'm studying Computer Science at Anhembi Morumbi, and I'm a Technician in Systems
										Development at Etec de Embu.`,
};
